<template>
    <div>
<!--        <el-divider class="sd" content-position="left"><el-tag>个人信息</el-tag></el-divider>-->
<!--        <el-divider class="sd" content-position="left">个人信息</el-divider>-->
<!--        <el-row :gutter="20">-->
<!--            <el-col :span="4"><div class="grid-content bg-purple">姓名:</div></el-col>-->
<!--            <el-col :span="2"><div class="grid-content bg-purple-light">HEILINE</div></el-col>-->
<!--            <el-col :span="4" :offset="4"><div class="grid-content bg-purple">求职意向:</div></el-col>-->
<!--            <el-col :span="4"><div class="grid-content bg-purple-light">Web前端</div></el-col>-->
<!--        </el-row>-->
<!--        <el-row :gutter="20">-->
<!--            <el-col :span="4"><div class="grid-content bg-purple">籍贯:</div></el-col>-->
<!--            <el-col :span="2"><div class="grid-content bg-purple-light">广东</div></el-col>-->
<!--            <el-col :span="4" :offset="4"><div class="grid-content bg-purple">学历:</div></el-col>-->
<!--            <el-col :span="4"><div class="grid-content bg-purple-light">大专</div></el-col>-->
<!--        </el-row>-->
<!--        <el-row :gutter="20">-->
<!--            <el-col :span="4"><div class="grid-content bg-purple">邮箱:</div></el-col>-->
<!--            <el-col :span="2"><div class="grid-content bg-purple-light">hljava@163.com</div></el-col>-->
<!--            <el-col :span="4" :offset="4"><div class="grid-content bg-purple">毕业院校:</div></el-col>-->
<!--            <el-col :span="6"><div class="grid-content bg-purple-light">广东交通职业技术学院</div></el-col>-->
<!--        </el-row>-->
<!--        <el-divider class="sd" content-position="left">专业技能</el-divider>-->
<!--        <div class="power">-->
<!--            1、熟悉DIV+CSS布局的HTML代码编写，能够根据交互原型和UI图完整制作出网页。-->
<!--            <br>-->
<!--            2、熟悉DOM操作，能熟悉运用JS，及jQuery对DOM进行节点的添加 、复制、删除、移动等操作。-->
<!--            <br>-->
<!--            3、熟悉Vue前端框架，熟悉使用Vue全家桶:vue-router、vuex等插件进行组件的封装，及构建项目。-->
<!--            <br>-->
<!--            4、熟悉Element-UI框架，能灵活采用里面的UI组件对各种项目进行快速的布局，极大提高开发效率和美观程度。-->
<!--            <br>-->
<!--            5、熟悉java后端语言，能熟练运用java编写jsp页面、servlet类,及通过servlet类给前端编写返回特定数据的接口。-->
<!--            <br>-->
<!--            6、熟练MySQL,能通过SQL语句对数据库进行查询、添加、更改、删除、及一些简单的排序条件子查询等操作，并能通过安装JDBC驱动，-->
<!--            结合java编写出对数据库自动进行特定的数据增删查改的servlet服务数据接口。-->
<!--            <br>-->
<!--            7、熟悉编写VBA及操作Excel等办公软件，能熟练的运用Excel对数据进行各种的布局设计，及一些常规的数据操作，能编辑一些比较复杂的数据查询公式，-->
<!--            熟悉编写VBA对Excel数据进行各种自动化操作，及对窗体等Excel自带比较多的插件功能设计利用、结合使用。-->
<!--            <br>-->
<!--            8、熟悉常用的:webstorm、eclipse、subline等编程工具的使用,了解git版本控制器，github、gitee远程仓库，及EmEditor正则文本处理软件，MarkDown文本编辑器的使用。-->
<!--            <br>-->
<!--            9、了解项目的部署，远程主机服务环境的搭建，有自己的阿里云主机，成功搭建了tomcat、nginx、MySQL等服务器环境并正常使用着。会简单的Linux命令操作。-->
<!--        </div>-->
        <el-divider class="sd" content-position="left">项目介绍</el-divider>

        <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item title="1、富文本的研究" name="1">
                <div>给每一行都添加上行号的实现</div>
                <div>对选中的内容进行一系列的:如添加标题的实现、文字颜色、大小、删除等DOM操作</div>
                <div>对代码进行高亮显示的研究</div>
            </el-collapse-item>
            <el-collapse-item title="2、背单词方式的研究" name="2">
                <div>实现单词的自动查询功能，一次复制一列单词，一次性查完，避免浪费大量时间在重复查单词上</div>
                <div>实现单词自动循环发音的功能，语音对学习单词太重要的</div>
                <div>实现单词拼写校对功能，只有用手把整个单词敲出来了，并且敲对了，这才算是过“脑子”了</div>
            </el-collapse-item>
            <el-collapse-item title="3、购物街" name="3">
<!--                <div>这个项目是学习B站上很出名的那个老师的，不是自己的</div>-->
<!--                <div>通过学习这个项目，学会并掌握了很多Vue框架相关方面的知识</div>-->
                <div>学会了不少组件的封装，但遇到Element-UI了之后，感觉自己封装出来的组件那些组件都没有了用武之地</div>
            </el-collapse-item>
            <el-collapse-item title="4、个人博客的搭建" name="4">
                <div>这个是我现在正在做的，我想打造一个类似个人博客的知识架构网站</div>
                <div>我会把我的一些想法，学到的知识，以及一些经历和感悟，记录在这里</div>
            </el-collapse-item>
        </el-collapse>
<!--            <div class="power">-->
<!--                5、利用markdown实现快速构建知识框架的研究-->
<!--                <br>-->
<!--                6、利用Excel实现发送ajax网络请求的研究-->
<!--                <br>-->
<!--                7、利用Excel实现对接欧路词典生词本API的连接，实现excel上的单词上传、查询、修改、删除的生词本备份跟手机保持同步的研究-->
<!--                <br>-->
<!--                8、利用Excel实现对字符串的正则匹配处理，并能对网络请求返回的字符串数据处理后，按照设定的格式存放在指定的表格中研究-->
<!--                <br>-->
<!--                9、利用Excel的窗体的WebBrowser1插件实现对单个Html文件的加载运行，结合markdown实现知识展现平台的研究-->
<!--                <br>-->
<!--                10、解决Excel的窗体的WebBrowser1插件内核是ES5浏览器，对一些JS写法不兼容的问题，实现单个HTML文件的js脚本能正常运行的研究-->
<!--                <br>-->
<!--                11、利用Excel实现批量对文件的进行复制、移动、写入、改名等自动化的研究-->
<!--            </div>-->
<!--        <el-divider class="sd" content-position="left">自我评价</el-divider>-->
    </div>
</template>

<script>
    export default {
        name: "IntroduceP",
        data() {
            return {
                activeNames: ['1']
            };
        },
        methods: {
            handleChange(val) {
                console.log(val);
            }
        }

    }
</script>

<style scoped>
    .power{
        text-align: left;
    }
    market_out.el-tabs__item{
        padding:0 10px;
    }
.sd{
    padding:0 10px;
}
    .el-row {
        margin-bottom: 20px;
    &:last-child {
         margin-bottom: 0;
     }
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
</style>